import React, { ReactElement } from 'react';
import { Button, Tile } from 'mesh-component-library';
import { useValidator } from '../../../redux/hooks/useValidator';
import useClaimData from '../../../redux/hooks/useClaimData';
import useAppStateData from '../../../redux/hooks/useAppStateData';
import { useOnEnter } from '../../../redux/hooks/useOnEnter';
import { ClaimDataField } from '../../../components/forms/ClaimDataField';
import useRedirectParams from '../../../redux/hooks/useRedirectParams';
import { useRouteProps } from '../../../redux/hooks/useRouteProps';
import DisplayValidationErrors from '../../../components/errors/DisplayValidationErrors';
import ValidationErrorExtraHelpToast from '../../../components/toasts/Toaster/Toaster';

const ValidationPage = (): ReactElement => {
    useRedirectParams();
    const { text, onClick } = useRouteProps();
    const { claimNumberOnEnter, zipCodeOnEnter } = useOnEnter();
    const { claimNumberFailedRegex, zipCodeFailedRegex } = useAppStateData();
    const { claimNumber, zipCode } = useClaimData();
    const { setZipCode, setClaimNumber, clearZipCode, clearClaimNumber, displayedZipCode, displayedClaimNumber } =
        useValidator();
    const isValidationButtonDisabled = claimNumber === '' || zipCode === '';

    return (
        <>
            <div data-testid="validation-page-body" className="page-body">
                <section data-testid="validation-page" className="body-section">
                    <div data-testid="validation-form">
                        <Tile className="validation-form">
                            <div data-testid="validation-form-body">
                                <div data-testid="validation-tile-body" className="validation-tile-body">
                                    <Tile.Body hasBorder={false}>
                                        <div data-testid="validation-form-error" className="validation-form">
                                            <DisplayValidationErrors />
                                        </div>
                                        <div data-testid="mesh-claim-number-field">
                                            <ClaimDataField
                                                className="claim-number-input"
                                                label="Claim Number"
                                                onChange={setClaimNumber}
                                                placeholder={displayedClaimNumber}
                                                value={claimNumber}
                                                onEnterPress={claimNumberOnEnter}
                                                onClear={clearClaimNumber}
                                                inputId="claim-number-input"
                                                fieldError={claimNumberFailedRegex}
                                                helpText="Enter your Allstate claim number"
                                                maxLength={12}
                                            />
                                        </div>
                                        <div data-testid="mesh-zip-code-field">
                                            <ClaimDataField
                                                label="Zip Code"
                                                onChange={setZipCode}
                                                placeholder={displayedZipCode}
                                                value={zipCode}
                                                onEnterPress={zipCodeOnEnter}
                                                onClear={clearZipCode}
                                                inputId="zip-code-input"
                                                fieldError={zipCodeFailedRegex}
                                                helpText="Enter the 5 digit ZIP code associated with your claim"
                                                maxLength={5}
                                            />
                                        </div>
                                    </Tile.Body>
                                </div>
                            </div>
                        </Tile>
                    </div>
                </section>
                <ValidationErrorExtraHelpToast />
                <div data-testid="validation-container" className="validation-container">
                    <div data-testid="validation-button" className="validation-button">
                        <Button
                            hasUpgrade
                            variant="information"
                            onClick={onClick}
                            disabled={isValidationButtonDisabled}
                            className="validation-button"
                        >
                            {text}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ValidationPage;
